import AddIcon from '@mui/icons-material/Add';
import { Box, Button, FormHelperText, Stack } from '@mui/material';
import { useState } from 'react';

import { EstablecimientoSelect } from '@/features/establecimientos/components/EstablecimientoSelect';

import { CrearEstablecimientoDialog } from './CrearEstablecimientoDialog';

interface EstablecimientoFieldWithCreateProps {
  value: string;
  onChange: (uid: string) => void;
  uidProfesional?: string;
  error?: boolean;
  helperText?: string;
}

export function EstablecimientoFieldWithCreate({
  value,
  onChange,
  uidProfesional,
  error,
  helperText,
}: EstablecimientoFieldWithCreateProps): JSX.Element {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <Box>
      <Stack direction="row" spacing={1} alignItems="flex-start">
        <Box sx={{ flex: 1 }}>
          <EstablecimientoSelect
            label="Establecimiento"
            required
            value={value}
            onChange={onChange}
            uidProfesional={uidProfesional}
            error={error}
          />
          {helperText && (
            <FormHelperText error={error} sx={{ mx: '14px' }}>
              {helperText}
            </FormHelperText>
          )}
        </Box>
        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => setDialogOpen(true)}
          sx={{ mt: 0.5, whiteSpace: 'nowrap' }}
        >
          Crear nuevo
        </Button>
      </Stack>
      <CrearEstablecimientoDialog
        open={dialogOpen}
        uidProfesional={uidProfesional}
        onCreated={(uid) => {
          onChange(uid);
          setDialogOpen(false);
        }}
        onCancel={() => setDialogOpen(false)}
      />
    </Box>
  );
}
